import { render, staticRenderFns } from "./LabelDetailTabsDialog.vue?vue&type=template&id=05e64a2e&scoped=true"
import script from "./LabelDetailTabsDialog.vue?vue&type=script&lang=js"
export * from "./LabelDetailTabsDialog.vue?vue&type=script&lang=js"
import style0 from "./LabelDetailTabsDialog.vue?vue&type=style&index=0&id=05e64a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e64a2e",
  null
  
)

export default component.exports